var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    staticClass: "m-0 mb-1",
    class: {
      cssClass: _vm.cssClass
    }
  }, _vm._l(_vm.list, function (_ref, index) {
    var _class;
    var icon = _ref.icon,
      label = _ref.label,
      content = _ref.content,
      variant = _ref.variant,
      afterFixLabel = _ref.afterFixLabel,
      top = _ref.top;
    return _c('b-col', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "d-flex",
      class: {
        ' align-items-center': !top,
        'align-items-start': top
      }
    }, [_c('sidebar-label', {
      attrs: {
        "title": _vm.$t(label),
        "icon": ("ezAr-icon-" + icon)
      }
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('label', {
      staticClass: "font-weight-bold",
      style: _vm.getStyleObject(index)
    }, [_vm._v(_vm._s(_vm.$t(label)) + " " + _vm._s(afterFixLabel) + " ")]), _c('span', {
      staticClass: "font-weight-bold mr-1"
    }, [_vm._v(":")])])]), _c('span', {
      class: (_class = {}, _class[("text-" + variant)] = variant, _class),
      staticStyle: {
        "word-break": "break-word",
        "margin-top": "2px"
      }
    }, [_vm._v(_vm._s(content))])], 1)]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }